// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"157":"0d07661a4f6be1aa","784":"21f249c683417c16"}[chunkId] + ".js";
};